export enum DeviceUsbTerminalType {
	SpeakerphoneNoEchoReduction = 'SPEAKERPHONE_NO_ECHO_REDUCTION',
	EchoCancelingSpeakerphone = 'ECHO_CANCELING_SPEAKERPHONE'
}
